import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContextMenuComponent } from '@perfectmemory/ngx-contextmenu';

import { UiService } from '../../../services/core.ui.service';
import { AdminService } from '../../../services/core.admin.service';
import { StateService } from '@uirouter/angular';

import { GfTitleService } from '../../../services/core.title.service';
import * as _ from 'lodash-es';

import { TroveAddModalComponent } from './trove-add-modal/admin.trove-add.modal.component';
import { TroveDeleteModalComponent } from './trove-delete-modal/admin.trove-delete.modal.component';
import { TroveMoveModalComponent } from './trove-move-modal/admin.trove-move.modal.component';

@Component({
    selector: 'admin-trove-view',
    template: require('./admin.trove.component.html')
})
export class AdminTroveViewComponent implements OnInit {

    @Input() parent: any = null;

    @Output() close = new EventEmitter<any>();

    @ViewChild(ContextMenuComponent, { static: true }) public itemMenu!: ContextMenuComponent<any>;

    protected categories: any = false;
    protected currentCategory: any = false;
    private stateParams: any = {};

    protected treeOptions: any = {
        displayField: 'title',
        idField: 'id',
        childrenField: 'nodes',
        getChildren: (node) => Promise.resolve(node.nodes)
    };

    constructor(

        private uiService: UiService,
        private adminService: AdminService,
        public stateService: StateService, 
        private $window: Window,
        private modalService: NgbModal,
        private titleService: GfTitleService,
    ) { }

    ngOnInit() {
        this.stateParams = this.stateService.params;

        this.fetch();

        this.treeOptions.onSelectItem = this.openCategory;
        this.treeOptions.contextMenu = this.itemMenu;

        this.titleService.setTitle('Site Admin', 'Categories');
    }

    buildCategoryPath(category) {
        var _path = [];
        _.each(category.categoryPath, (item) => {
            if (!item.isRoot) {
                _path.push(item.title);
            }
        });

        return _path.join('/');
    }

    save() {
        var category = {
            id: this.currentCategory.id,
            alias: this.currentCategory.category.alias,
            categoryName: this.currentCategory.category.categoryName,
            description: this.currentCategory.category.description,
            showInSearch: this.currentCategory.category.showInSearch ? 'Y' : 'N',
            accessLevel: this.currentCategory.category.accessLevel
        };
        this.adminService.postTrove(this.currentCategory.id, category)
            .then(() => {
                this.currentCategory.title = category.categoryName;
                this.uiService.message.showSuccess('Successfully updated category ' + this.currentCategory.title);
            }, () => {
                this.uiService.message.showError('Failed to updated category ' + this.currentCategory.title);
            });
    }

    saveCategoryParent(category, parent) {
        var save = {
            id: category.id,
            parentCategoryId: parent.id
        };
        this.adminService.postTrove(category.id, save)
            .then(() => {
                category.parentCategoryId = parent.id;
                this.uiService.message.showSuccess('Moved ' + category.title + ' under ' + parent.title);
            }, () => {
                this.uiService.message.showError('Sorry, could not move category ' + category.title + ' under ' + parent.title);
            });
    }

    openCategory = (category) => {
        this.setCurrentCategory(category);
        this.updateState('selected', category.id);
    };

    onCategoryContextMenu(action, category) {
        switch (action) {
            case 'add': this.showAddCategory(category); break;
            case 'delete': this.showDeleteCategory(category); break;
        }
    }

    showAddCategory(parent) {
        const modalRef = this.modalService.open(TroveAddModalComponent);
        modalRef.componentInstance.parent = parent;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.fetch();
        });
    }

    showDeleteCategory(category) {
        const modalRef = this.modalService.open(TroveDeleteModalComponent);
        modalRef.componentInstance.category = category;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.fetch();
        });
    }

    showMoveCategory(category) {
        const modalRef = this.modalService.open(TroveMoveModalComponent);
        modalRef.componentInstance.category = category;
        modalRef.componentInstance.categories = _.cloneDeep(this.categories);
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.fetch();
        });
    }

    fetch(keepCurrent = false) {
        this.categories = false;

        if (!keepCurrent) {
            this.currentCategory = null;
        }

        this.adminService.troveCategories()
            .then((ret: any) => {
                this.categories = [this.createCategoryTree(ret.items)];
            }
        );
    }

    updateState(key, value) {
        var params = {};
        params[key] = value;

        this.stateService.transitionTo(
            'home.admin.trove',
            params,
            {
                location: true, //This makes it update URL
                inherit: true,
                relative: this.stateService.current.name,
                notify: false //This makes it not reload
            }
        );
    }

    setCurrentCategory(category) {
        _.slice(category.categoryPath, 0, -1).forEach((node: any) => {
            node.expanded = true;
        });

        this.treeOptions.selectedItem = category;
        this.currentCategory = category;

        return category;
    }

    findCategory(haystack, id) {
        if (haystack.id == id) {
            return haystack;
        }

        _.each(haystack.nodes, (item) => {
            var found = this.findCategory(item, id);
            if (found) {
                return found;
            }
        });

        return false;
    }

    createCategoryTree(items) {
        var categories = _.cloneDeep(items);

        //Find incoming (root) category
        var rootCategory = _.remove(categories, { id: 0 });

        var rootNode: any = false;
        if (rootCategory?.length > 0) {
            rootNode = this.createCategoryNode(rootCategory[0], true, 0);
        } else {
            rootNode = this.createRootNode();
        }

        rootNode.categoryPath = [rootNode];
        rootNode.nodes = this.createCategorySubTree(0, categories, 1, rootNode.categoryPath);
        if (!this.currentCategory) {
            this.openCategory(rootNode);
        }
        return rootNode;
    }

    createCategorySubTree(parentCategoryId, categorys, level, categoryPath) {
        var nodes = [];

        var children = _.filter(categorys, { parentCategoryId: parentCategoryId });

        children.forEach((category) => {
            var _categoryPath = [];
            _.each(categoryPath, (pathNode) => {
                _categoryPath.push(pathNode);
            });
            var node = this.createCategoryNode(category, false, level);
            _categoryPath.push(node);
            node.categoryPath = _categoryPath;
            node.nodes = this.createCategorySubTree(category.id, categorys, level + 1, _categoryPath);
            if (node.id == this.stateParams.selected) {
                this.openCategory(node);
            }
            nodes.push(node);
        });

        nodes = _.sortBy(nodes, (node) => {
            return node.title.toLowerCase();
        });

        return nodes;
    }

    createRootNode() {
        return this.createCategoryNode(
            { id: 0 }, true, 0
        );
    }

    createCategoryNode(category, isRoot, level) {
        return {
            id: category.id,
            title: ((isRoot) ? 'Root' : category.categoryName),
            nodes: [],
            isPublic: (category.isPublic == 'Y') ? true : false,
            parentCategoryId: (isRoot) ? -1 : category.parentCategoryId,
            isRoot: (isRoot) ? true : false,
            isSet: category.isSet,
            level: level,
            expanded: isRoot,
            isMonitored: category.isMonitored,
            category: category,
            categoryPath: null
        };
    }
}
